import React from 'react';
import ExamListTable from './table';

class ExamList extends React.Component {
	render() {
		return(
			<div style={{marginTop: -50}}>
				<ExamListTable />
			</div>
		);
	} 
}

export default ExamList;